<template>
  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <title>send-email-1</title>
    <path
      d="M23.612.225a1.045,1.045,0,0,0-1.138-.1L.827,11.646a1.547,1.547,0,0,0,.125,2.8l3.254,1.38a.719.719,0,0,0,.043.245l2.5,6.746A1.817,1.817,0,0,0,8.463,24a1.846,1.846,0,0,0,1.219-.474c.039-.035,2.79-3.078,3.4-3.754a.249.249,0,0,1,.283-.062l3.157,1.339a1.591,1.591,0,0,0,1.3-.027,1.563,1.563,0,0,0,.835-.983L23.961,1.3A1.014,1.014,0,0,0,23.612.225ZM5.838,16.046,15.53,7.983A.226.226,0,0,1,15.867,8a.219.219,0,0,1,.019.332L8.648,17.187a.728.728,0,0,0-.157.351l-.633,3.95Z"
    />
  </svg>
</template>
